// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2DflM","toggleWrap":"styles_toggleWrap__2Hrd7","content":"styles_content__3oFgv","selectAreaCode":"styles_selectAreaCode__3WF53"};